module.exports = __webpack_public_path__ + "static/img/req.3f928a43.png";